import { render, staticRenderFns } from "./MDTPresent.vue?vue&type=template&id=dc1fcda4&"
import script from "./MDTPresent.vue?vue&type=script&lang=ts&"
export * from "./MDTPresent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc1fcda4')) {
      api.createRecord('dc1fcda4', component.options)
    } else {
      api.reload('dc1fcda4', component.options)
    }
    module.hot.accept("./MDTPresent.vue?vue&type=template&id=dc1fcda4&", function () {
      api.rerender('dc1fcda4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboards/MDTPresent.vue"
export default component.exports